import React, {useEffect, useState} from "react";
import API from "../../helpers/Axios";
import moment from "moment";
import AppStyles from "../../AppStyles";
import StudioStatus from "../../components/StudioStatus";
import StudioDataScreen from "../modals/StudioDataScreen";

const summaryCards = [
	{
		title: "Stored files amount",
		value: "2.341",
		icon: (
			<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					clipRule="evenodd"
					d="M15.001 19.403v-8.54c0-.426-.169-.833-.469-1.133l-2.263-2.263c-.3-.3-.707-.47-1.132-.47h-5.54a1.6 1.6 0 0 0-1.6 1.602v10.804a1.6 1.6 0 0 0 1.6 1.6h7.804a1.6 1.6 0 0 0 1.6-1.6Z"
					stroke="#58B17D"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.001 17.002h3.402a1.6 1.6 0 0 0 1.6-1.6V6.86c0-.425-.169-.832-.469-1.133l-2.263-2.263c-.3-.3-.707-.469-1.132-.469h-5.54a1.6 1.6 0 0 0-1.6 1.6v2.402"
					stroke="#58B17D"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M20.003 6.998h-3.201a.8.8 0 0 1-.8-.8V2.996M15.001 11H11.8a.8.8 0 0 1-.8-.8V6.997"
					stroke="#58B17D"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
	},
	{
		title: "Global storage size",
		value: (
			<>
				32.189.41<span className="text-sm">GB</span>
			</>
		),
		icon: (
			<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					clipRule="evenodd"
					d="M15.001 19.403v-8.54c0-.426-.169-.833-.469-1.133l-2.263-2.263c-.3-.3-.707-.47-1.132-.47h-5.54a1.6 1.6 0 0 0-1.6 1.602v10.804a1.6 1.6 0 0 0 1.6 1.6h7.804a1.6 1.6 0 0 0 1.6-1.6Z"
					stroke="#58B17D"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.001 17.002h3.402a1.6 1.6 0 0 0 1.6-1.6V6.86c0-.425-.169-.832-.469-1.133l-2.263-2.263c-.3-.3-.707-.469-1.132-.469h-5.54a1.6 1.6 0 0 0-1.6 1.6v2.402"
					stroke="#58B17D"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M20.003 6.998h-3.201a.8.8 0 0 1-.8-.8V2.996M15.001 11H11.8a.8.8 0 0 1-.8-.8V6.997"
					stroke="#58B17D"
					strokeWidth={1.5}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
	},
];

function DataScreen() {
	const [currentStudio, setCurrentStudio] = useState(null);
	const [isDetailsVisible, setIsDetailsVisible] = useState(false);
	const [studiosData, setStudiosData] = useState(null);
	const [isStudiosLoading, setIsStudiosLoading] = useState(true);

	const getStudios = (url = "admin/studios") => {
		API.post(url, {approved: 1})
			.then((res) => {
				setStudiosData(res.data);
				setIsStudiosLoading(false);
			})
			.catch((error) => {
				console.log(error);
				setIsStudiosLoading(false);
			});
	};

	useEffect(() => {
		getStudios();
	}, []);

	return (
		<div className="flex-1">
			{isDetailsVisible ? (
				<div
					className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(0,0,0,0.45)] p-4"
					onClick={() => setIsDetailsVisible(false)}
				>
					<div
						className="w-full max-w-[900px] rounded-lg border border-[#eee] bg-white shadow-[0_2px_12px_rgba(0,0,0,0.1)]"
						onClick={(e) => e.stopPropagation()}
					>
						<StudioDataScreen item={currentStudio} setIsVisible={setIsDetailsVisible} type="studio" />
					</div>
				</div>
			) : null}

			<div className="h-full overflow-auto p-10">
				<h1 className="text-5xl font-semibold">Data Storage</h1>
				<p className="mt-4 text-xl text-[#595959]">All about stugo data.</p>

				<div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
					{summaryCards.map((item) => (
						<div key={item.title} className="rounded-lg bg-[#1A1A1A] p-4">
							<div className="flex items-center justify-between">
								<div>
									<p className="text-sm font-bold text-[#A0AEC0]">{item.title}</p>
									<p className="mt-2 text-2xl font-bold text-white">{item.value}</p>
								</div>
								<div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#EDFDF4]">
									{item.icon}
								</div>
							</div>
						</div>
					))}
				</div>

				<h2 className="mt-10 text-2xl font-semibold text-[#096730]">Studio&apos;s storage</h2>

				<div className="mt-10 rounded-lg bg-white shadow-[0_2px_10px_rgba(0,0,0,0.08)]">
					<div className="border-b border-[#E4E1E0]">
						<div className="inline-block border-b-2 border-[#096730] px-4">
							<p className="leading-10 text-base font-semibold text-[#096730]">All Studios</p>
						</div>
					</div>

					<table className="w-full border-collapse">
						<thead>
							<tr className="h-12 bg-[#F8F8F8]">
								<th className="px-4" />
								<th className="px-4 text-left text-sm font-semibold text-[#1E1F21]">Studio Name</th>
								<th className="px-4 text-left text-sm font-semibold text-[#1E1F21]">Number of files</th>
								<th className="px-4 text-left text-sm font-semibold text-[#1E1F21]">File types</th>
								<th className="px-4 text-left text-sm font-semibold text-[#1E1F21]">Studio plan used</th>
							</tr>
						</thead>
						<tbody>
							{studiosData?.data?.map((item) => (
								<tr
									key={item.id}
									className="h-16 cursor-pointer"
									onClick={() => {
										setCurrentStudio(item);
										setIsDetailsVisible(true);
									}}
								>
									<td className="border-b border-[#E4E1E0] px-4">
										<img src={item.artwork_url} alt={item.name} className="h-8 w-8 rounded-2xl object-cover" />
									</td>
									<td className="border-b border-[#E4E1E0] px-4">
										<div>
											<p>{item.name}</p>
											<p className="mt-1 font-semibold text-[#909090]">{item.user?.email}</p>
										</div>
									</td>
									<td className="border-b border-[#E4E1E0] px-4">
										<p>{item.user ? AppStyles.utils.formatPhoneNumber(item.user.phone_number) : ""}</p>
									</td>
									<td className="border-b border-[#E4E1E0] px-4">
										<p>{moment.utc(item.created_at).local().format("MMM D, YYYY")}</p>
									</td>
									<td className="border-b border-[#E4E1E0] px-4">
										<StudioStatus status={item.approved} />
									</td>
								</tr>
							))}
						</tbody>
					</table>

					{studiosData ? (
						<div className="flex h-12 items-center justify-end bg-[#F8F8F8] px-6">
							<div className="mr-10 flex items-center">
								<p className="mr-2 font-semibold">Rows per page: {studiosData.per_page}</p>
								<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 14 8 9h8l-4 5Z" fill="#6D6E6F" />
								</svg>
							</div>
							<p className="font-semibold">
								{studiosData.from}- {studiosData.to}
							</p>
							<div className="ml-10 flex w-20 items-center justify-between">
								<button
									type="button"
									onClick={() => {
										if (!studiosData.prev_page_url) return;
										setIsStudiosLoading(true);
										getStudios(studiosData.prev_page_url);
									}}
									disabled={!studiosData.prev_page_url}
								>
									<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M14.8 8.106c.628-.593-.367-1.533-.995-.89L9.196 11.52a.66.66 0 0 0 0 .94l4.609 4.352c.628.593 1.623-.346.995-.94l-4.085-3.857L14.8 8.106Z"
											fill={studiosData.prev_page_url ? "#6D6E6F" : "#ccc"}
										/>
									</svg>
								</button>
								{isStudiosLoading ? (
									<div className="h-4 w-4 animate-spin rounded-full border-2 border-[#096730] border-t-transparent" />
								) : null}
								<button
									type="button"
									onClick={() => {
										if (!studiosData.next_page_url) return;
										setIsStudiosLoading(true);
										getStudios(studiosData.next_page_url);
									}}
									disabled={!studiosData.next_page_url}
								>
									<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M9.2 8.106c-.628-.593.367-1.533.995-.89l4.609 4.303a.66.66 0 0 1 0 .94l-4.609 4.352c-.628.593-1.623-.346-.995-.94l4.085-3.857L9.2 8.106Z"
											fill={studiosData.next_page_url ? "#6D6E6F" : "#ccc"}
										/>
									</svg>
								</button>
							</div>
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
}

export default DataScreen;
